/**
 * Ce que la caisse exige du navigateur pour demarrer (plan, section 1.7) :
 * pas de repli faible. Sans WebCrypto, pas de cle de signature ; sans
 * IndexedDB, rien ne survit a la fermeture de Chrome.
 *
 * @returns {Array<'webcrypto'|'indexeddb'>} ce qui manque (vide = tout est la)
 */
export function missingCapabilities(win = globalThis.window) {
    const missing = [];
    const subtle = win && win.crypto && win.crypto.subtle;
    if (!subtle || typeof subtle.generateKey !== 'function') missing.push('webcrypto');
    const nav = win && win.navigator;
    const hasBuckets = Boolean(nav && nav.storageBuckets && typeof nav.storageBuckets.open === 'function');
    if (!(win && win.indexedDB) && !hasBuckets) missing.push('indexeddb');
    return missing;
}
